export const EXPORT_COOKIE = {
    minutesToExpire: 5,
    value: 'yes',
    name: {
        companyRolesExportDisabled: 'companyRolesExportDisabled',
        customerRolesExportDisabled: 'customerRolesExportDisabled'
    }
}
